import React from 'react';
import styled from 'styled-components';
import ToggleIcon from './ToggleIcon';
export const InputStyle = styled.input `
  height: 40px;
  background: ${(props) => props.theme.ghostWhite}
  color: ${(props) => props.theme.navyBlue};
  padding-left: 10px;
  padding-right: ${(props) => (props.toggleIconProps ? '45px' : '10px')};
  border: 0;
  outline: none;
  line-height: 21px;
  z-index: 2;
  padding-top: 3px;
  border: 1px solid ${(props) => props.theme.gray};
  border-radius: 4px;
  &:-webkit-autofill,
  &:-webkit-autofill:hover, 
  &:-webkit-autofill:focus, 
  &:-webkit-autofill:active  {
    -webkit-box-shadow: 0 0 0 30px ${(props) => props.theme.ghostWhite} inset !important;
  } 
  font-size: 0;
`;
const Input = ({ inputProps, toggleIconProps }) => (React.createElement(React.Fragment, null,
    toggleIconProps && React.createElement(ToggleIcon, Object.assign({}, toggleIconProps)),
    React.createElement(InputStyle, Object.assign({}, inputProps, { toggleIconProps: toggleIconProps }))));
export default Input;
